import React from 'react';
import type { SVGProps } from 'react';

import zapierLogoUrl from '../../../../assets/icons/Zapier.svg?url';

interface ZapierIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const ZapierIcon: React.FC<ZapierIconProps> = ({ size = 20 }) => (
  <img
    src={zapierLogoUrl}
    width={size}
    height={size}
    alt="Zapier"
    style={{ display: 'block' }}
  />
);

export default ZapierIcon;
